import PropTypes from "prop-types"

const AssetShape = PropTypes.exact({
  url: PropTypes.string,
  path: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  isPublic: PropTypes.bool,
  description: PropTypes.string,
})

export default AssetShape
